import React from 'react';

import { useImageFallback } from '@/hooks/useImageFallback.ts';

interface ImageProps extends React.ImgHTMLAttributes<HTMLImageElement> {
  fallback?: string;
}

export const Image = ({
  fallback,
  src,
  alt,
  onError,
  onLoad,
  style,
  ...props
}: ImageProps) => {
  const { imageSrc, handleError } = useImageFallback(
    src,
    fallback ?? '/img_404.png'
  );

  return (
    <img
      {...props}
      src={imageSrc}
      alt={alt}
      onLoad={(e) => {
        onLoad?.(e);
      }}
      onError={(e) => {
        handleError(e);
        onError?.(e);
      }}
      style={{ ...style }}
    />
  );
};
